

























import {Component, Prop, Vue} from "vue-property-decorator";

import NoBillingExistence from "@/components/billing/NoBillingExistence.vue";

import InvoiceApi from "@/consoleapi/api/invoice";
import store from '@/store';

import {mapGetters} from "vuex";
import {int} from "aws-sdk/clients/datapipeline";
import InvoiceInfo from "@/consoleapi/api/invoice_info";
import AuthMypage from "@/authorization/auth_mypage";
import SelectSection from "@/components/users/SelectSection.vue";

@Component({
  components:{
    NoBillingExistence,
  },
    computed:
        mapGetters({
            progress:'billing/progress'
        }),
})

export default class Billing extends Vue {
    private invoices = [];
    private params = "";

    @Prop() bearerToken!: string;
    @Prop() accountId!: string;
    @Prop() userId!: string;

    mounted() {
        this.getBillingInfo();
        const invoiceApi = new InvoiceApi();
        invoiceApi.setBearerToken(this.bearerToken);
        invoiceApi.show(this.accountId).then(response => {
            this.invoices = response.data.invoices;
            if(this.invoices.length){
                store.dispatch('billing/pushProgress', 'display');
            } else {
                store.dispatch('billing/pushProgress', 'none');
            }
        }).catch(error => {
            //console.log(error.response);
        });
    }

    getPdf(invoiceId: int){
        //console.log("getPdf");
        return "http://13.112.202.173/api/v1/charges/5f4dd26fb3e14/invoices/" + invoiceId +  "?" + this.params;
    }

    getBillingInfo(){
        const invoiceInfo = new InvoiceInfo();
        invoiceInfo.setBearerToken(this.bearerToken);
        invoiceInfo.get(this.accountId).then(response => {
            const billingInfo = response.data;
            this.params = "address=" + billingInfo.billing_address;
            this.params += "&company_name=" + billingInfo.billing_company;
            this.params += "&name=" + billingInfo.billing_name;
            //console.log(this.params);
        }).catch(error => {
            if(error.response.status === 404) {
                this.getInfo();
            }
        });

    }

    getInfo(){
        const auth = new AuthMypage();
        auth.getInitialize(Vue.$cookies.get(String(process.env.VUE_APP_COOKIE_BEARER_TOKEN))).then(response => {
            const info = response.data;
            this.params = "address=" + info.address;
            this.params += "&company_name=" + info.company_name;
            this.params += "&name=" + info.name;
            //console.log();
        });
    }
}
